{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mpers_2022-12-31/ssmt-fs-mpers_2022-12-31_role-730000",
  "sheetId": "NotesListOfNotes",
  "label": "[730000] Notes - List of Notes",
  "description": "Comprehensive list of all notes to the financial statements (MPERS - 83 note disclosures)",
  "controls": [
    {
      "qname": "ssmt-mpers:DisclosureOfAcquisitionsAndDisposalsExplanatory",
      "label": "Disclosure of acquisition and disposal of subsidiary",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfAuditorsRemunerationExplanatory",
      "label": "Disclosure of auditors' remuneration",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfAuthorisationOfFinancialStatementsExplanatory",
      "label": "Disclosure of authorisation of financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfBasisOfPreparationOfFinancialStatementsExplanatory",
      "label": "Disclosure of basis of preparation of financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfBiologicalAssetsAndGovernmentGrantsForAgriculturalActivityExplanatory",
      "label": "Disclosure of biological assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfBorrowingsExplanatory",
      "label": "Disclosure of borrowings",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCapitalAndReserveExplanatory",
      "label": "Disclosure of capital and reserves",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCashAndCashEquivalentsExplanatory",
      "label": "Disclosure of cash and cash equivalents",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfChangesInAccountingPoliciesAccountingEstimatesAndErrorsExplanatory",
      "label": "Disclosure of changes in accounting policies, accounting estimates and errors",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfClaimsAndBenefitsPaidExplanatory",
      "label": "Disclosure of claims and benefits paid",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCollateralExplanatory",
      "label": "Disclosure of collateral",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCommitmentsExplanatory",
      "label": "Disclosure of commitments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfContingentAssetsAndContingentLiabilitiesExplanatory",
      "label": "Disclosure of contingent assets and contingent liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfConvertibleNotesExplanatory",
      "label": "Disclosure of convertible notes",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCostOfSalesExplanatory",
      "label": "Disclosure of cost of sales",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCreditRiskExplanatory",
      "label": "Disclosure of credit risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfCurrentTaxAssetsAndCurrentTaxLiabilitiesExplanatory",
      "label": "Disclosure of current tax assets or current tax liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDeferredIncomeExplanatory",
      "label": "Disclosure of deferred income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDeferredTaxesExplanatory",
      "label": "Disclosure of deferred tax assets/(liabilities)",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDepositsFromBanksExplanatory",
      "label": "Disclosure of deposits from banks",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDepreciationAndAmortisationExpenseExplanatory",
      "label": "Disclosure of depreciation and amortisation expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDerivativeFinancialInstrumentsExplanatory",
      "label": "Disclosure of derivative financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDiscontinuedOperationsExplanatory",
      "label": "Disclosure of discontinued operations",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfDividendsExplanatory",
      "label": "Disclosure of dividends",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfEarningsPerShareExplanatory",
      "label": "Disclosure of earnings/loss per share",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfEffectOfChangesInForeignExchangeRatesExplanatory",
      "label": "Disclosure of effect of changes in foreign exchange rates",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfEmploymentTerminationBenefitsExplanatory",
      "label": "Disclosure of employment termination benefits",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfEntitysReportableSegmentsExplanatory",
      "label": "Disclosure of entity's operating segments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfExplanationOfTransitionToMPERSExplanatory",
      "label": "Disclosure of explanation of transition to the MPERS",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfFeeAndCommissionIncomeExpenseExplanatory",
      "label": "Disclosure of fee and commission income (expense)",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfFinanceCostExplanatory",
      "label": "Disclosure of finance costs",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfFinanceIncomeExplanatory",
      "label": "Disclosure of finance income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfFinancialInstrumentsExplanatory",
      "label": "Disclosure of financial instruments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfFinancialInstrumentsMeasuredAtAmortisedCostExplanatory",
      "label": "Disclosure of financial instrument measured at amortised cost",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfFinancialInstrumentsAtFairValueThroughProfitOrLossExplanatory",
      "label": "Disclosure of financial instruments at fair value through profit or loss",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfFirstTimeAdoptionExplanatory",
      "label": "Disclosure of first-time adoption",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfForeignCurrencyTranslationReserveExplanatory",
      "label": "Disclosure of foreign currency",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfGeneralInformationAboutFinancialStatementsExplanatory",
      "label": "Disclosure of general information about financial statements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfGoingConcernExplanatory",
      "label": "Disclosure of going concern",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfGrantsAndContributionsExplanatory",
      "label": "Disclosure of government grants",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfHedgingActivityExplanatory",
      "label": "Disclosure of hedging activities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfImpairmentOfAssetsExplanatory",
      "label": "Disclosure of impairment of assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfIncomeTaxExplanatory",
      "label": "Disclosure of income tax expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfIntangibleAssetsAndGoodwillExplanatory",
      "label": "Disclosure of intangible assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfInterestExpenseExplanatory",
      "label": "Disclosure of interest expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfInterestInAssociatesJointVenturesOrJointlyControlledOperationExplanatory",
      "label": "Disclosure of interest in associates, joint ventures or jointly controlled operation",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfInterestIncomeExplanatory",
      "label": "Disclosure of interest income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfInventoriesExplanatory",
      "label": "Disclosure of inventories",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfInvestmentInJointlyControlledExplanatory",
      "label": "Disclosure of investment in jointly controlled entities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfInvestmentInSubsidiaryCompaniesExplanatory",
      "label": "Disclosure of investment in subsidiaries",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfInvestmentPropertyExplanatory",
      "label": "Disclosure of investment property",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfInvestmentInAssociateExplanatory",
      "label": "Disclosure of investment in associates",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfLeasesExplanatory",
      "label": "Disclosure of leases",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfLiquidityRiskExplanatory",
      "label": "Disclosure of liquidity risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfLoansAndAdvancesToBanksExplanatory",
      "label": "Disclosure of loans and advances to banks",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfMarketRiskExplanatory",
      "label": "Disclosure of market risk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfNonAdjustingEventsAfterEndOfReportingPeriodExplanatory",
      "label": "Disclosure of non-adjusting events after the end of reporting period",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfNoncontrollingInterestsExplanatory",
      "label": "Disclosure of non-controlling interests",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfNoncurrentAssetsHeldForSaleAndDiscontinuedOperationsExplanatory",
      "label": "Disclosure of non-current assets or disposal groups classified as held for sale",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherComprehensiveIncomeExplanatory",
      "label": "Disclosure of other comprehensive income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherCurrentAssetsExplanatory",
      "label": "Disclosure of other current assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherCurrentLiabilitiesExplanatory",
      "label": "Disclosure of other current liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherIncomeExplanatory",
      "label": "Disclosure of other income",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherInvestmentsExplanatory",
      "label": "Disclosure of other investments",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherLongTermEmploymentBenefitsExplanatory",
      "label": "Disclosure of other long-term employment benefits",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherNoncurrentAssetsExplanatory",
      "label": "Disclosure of other non-current assets",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherNoncurrentLiabilitiesExplanatory",
      "label": "Disclosure of other non-current liabilities",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherNotesToAccountsExplanatory",
      "label": "Disclosure of other notes to accounts",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherOperatingExpenseExplanatory",
      "label": "Disclosure of other operating expense",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfOtherReservesExplanatory",
      "label": "Disclosure of other reserves",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfPerpetualSukukExplanatory",
      "label": "Disclosure of perpetual sukuk",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfPostEmploymentBenefitObligationsExplanatory",
      "label": "Disclosure of post employment benefit obligation",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfProfitAfterTaxExplanatory",
      "label": "Disclosure of profit or loss for the year",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfPropertyPlantAndEquipmentExplanatory",
      "label": "Disclosure of property, plant and equipment",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfProvisionsExplanatory",
      "label": "Disclosure of provisions",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfRedeemablePreferenceSharesExplanatory",
      "label": "Disclosure of redeemable preference shares",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfRevenueExplanatory",
      "label": "Disclosure of revenue",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfServiceConcessionArrangementsExplanatory",
      "label": "Disclosure of service concession arrangements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfShareCapitalReservesAndOtherEquityInterestExplanatory",
      "label": "Disclosure of share capital",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ifrs-smes:DisclosureOfSharebasedPaymentArrangementsExplanatory",
      "label": "Disclosure of share-based payment arrangements",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfSubsequentEventsExplanatory",
      "label": "Disclosure of subsequent event",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfTradeAndOtherPayablesExplanatory",
      "label": "Disclosure of trade and other payables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    },
    {
      "qname": "ssmt-mpers:DisclosureOfTradeAndOtherReceivablesExplanatory",
      "label": "Disclosure of trade and other receivables",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 6
      }
    }
  ]
}
